// @ts-check

import { api } from '@/api'

export const submitBusinessAccountPayment = async (outgoingPayments) => {
  const { data: outGoingPayment } = await api.post('outgoing-payments', {
    ...outgoingPayments
  })
  return outGoingPayment
}

export const submitSwanPayment = async (outgoingPayments) => {
  const { data: consent } = await api.post(
    'outgoing-payments/create-swan-payment',
    {
      outgoing_payments: [outgoingPayments]
    }
  )
  return consent
}

export const handleSwanConsent = async (consentId) =>
  api.get(`swan/swan-consent-handling/${consentId}`)

export const getBusinessAccountOnboardingData = async () =>
  api.get('swan/onboarding-form')

export const createBusinessAccountOnboarding = async (onboardingInfo) =>
  api.post('swan/create-onboarding', { ...onboardingInfo })

export const getBusinessAccountOnboarding = async () =>
  api.get('swan/onboarding-link')

export const createAuthorizationUrl = async () =>
  api.post('swan/create-authorization-url')

export const createIdentificationUrl = async () =>
  api.post('swan/create-identification-url')

// State and code as payload
export const finalizeOnboardingAfterAuthorization = async (payload) =>
  api.post('swan/finalize-onboarding-after-authorization', payload)

/**
 * @returns {Promise<SwanCanCloseResource>}
 */
export const canCloseAccount = async () => {
  const res = await api.get('swan/can-close')
  return res.data
}

/**
 * @param {LocalizedPayload|undefined} params
 * @returns {Promise<RestrictionStatusResource>}
 */
export const canOpenAccount = async (params) => {
  const res = await api.get('swan/can-open', { params })
  return res.data
}

export const closeAccount = async (params) =>
  api.get('swan/close-account', { params })

export const transferFundsAndCloseAccount = async (payload) =>
  api.post('swan/transfer-funds-and-close-account', payload)
